<template>
  <!-- 新增摘要内容 -->
  <div class="abstract-block">
    <!-- 审核摘要 -->
    <section
      v-if="checkPermission('审核:提交摘要', permList)"
      class="container-suspects marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">审核摘要</span>
        </div>
        <div class="item-block">
          <el-input
            v-model="auditPaper"
            type="textarea"
            class="textarea-block"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            :rows="3"
          />
          <div class="button-block flex">
            <el-button
              icon="el-icon-upload"
              type="primary"
              size="small"
              class="btn"
              :disabled="isCaseArchive"
              @click="onAddCaseAbstract(1001, 'auditPaper')"
            >
              提交
            </el-button>
          </div>
        </div>
      </el-card>
    </section>

    <!-- 沟通摘要 -->
    <section
      v-if="checkPermission('沟通:提交摘要', permList)"
      class="container-suspects marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">沟通摘要</span>
        </div>
        <div class="item-block">
          <el-input
            v-model="communicationPaper"
            type="textarea"
            class="textarea-block"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            :rows="3"
          />
          <div class="button-block flex">
            <el-button
              icon="el-icon-upload"
              type="primary"
              size="small"
              class="btn"
              :disabled="isCaseArchive"
              @click="onAddCaseAbstract(1002, 'communicationPaper')"
            >
              提交
            </el-button>
          </div>
        </div>
      </el-card>
    </section>

    <!-- 客诉摘要 -->
    <section
      v-if="checkPermission('客诉:提交摘要', permList)"
      class="container-suspects marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">客诉摘要</span>
        </div>
        <div class="item-block">
          <el-row class="item-content">
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">申诉人姓名</p>
              <el-input
                v-model="currentAppeals.name"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">联系方式</p>
              <el-input
                v-model="currentAppeals.phone"
                class="input-block"
                placeholder="请输入内容"
                maxlength="11"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">性格</p>
              <el-input
                v-model="currentAppeals.character"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">理解能力</p>
              <el-input
                v-model="currentAppeals.comprehension"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">申诉来源</p>
              <el-input
                v-model="currentAppeals.origin"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">申诉次数</p>
              <el-input
                v-model="currentAppeals.times"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">处理结果</p>
              <el-input
                v-model="currentAppeals.result"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">预约跟进时间</p>
              <el-date-picker
                v-model="currentAppeals.followUpTime"
                type="date"
                class="input-block"
                placeholder="请输入内容"
                clearable
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="24" class="list-block flex">
              <p class="title-txt">申诉内容</p>
              <el-select v-model="currentAppeals.appealOption" placeholder="请选择" class="select-block">
                <el-option
                  v-for="item in appealOptionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <div class="other-input">
                <el-input
                  v-if="Number(currentAppeals.appealOption) === 7"
                  v-model="currentAppeals.content"
                  placeholder="请输入内容"
                  clearable
                />
              </div>
            </el-col>
          </el-row>
          <el-input
            v-model="customerComplaintPaper"
            type="textarea"
            class="textarea-block"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            :rows="3"
          />
          <div class="button-block flex">
            <el-button
              icon="el-icon-upload"
              type="primary"
              size="small"
              class="btn"
              :disabled="isCaseArchive"
              @click="onAddCaseAbstract(1003, 'customerComplaintPaper')"
            >
              提交
            </el-button>
          </div>
        </div>
      </el-card>
    </section>

    <!-- 法务摘要 -->
    <section
      v-if="checkPermission('法务:提交摘要', permList)"
      class="container-suspects marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">法务摘要</span>
        </div>
        <div class="item-block">
          <el-row class="item-content">
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">原告</p>
              <el-input
                v-model="currentLegalAffairs.plaintiff"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">被告</p>
              <el-input
                v-model="currentLegalAffairs.defendant"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">原告代理人</p>
              <el-input
                v-model="currentLegalAffairs.defendantAgent"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="6" class="list-block flex">
              <p class="title-txt">诉讼标的额</p>
              <el-input
                v-model="currentLegalAffairs.amountOfLitigation"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="8" class="list-block flex">
              <p class="title-txt">案号</p>
              <el-input
                v-model="currentLegalAffairs.caseNum"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="8" class="list-block flex">
              <p class="title-txt">受理法院</p>
              <el-input
                v-model="currentLegalAffairs.courtOfAppeal"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="4" class="list-block flex">
              <p class="title-txt">主审法官姓名</p>
              <el-input
                v-model="currentLegalAffairs.presidingJudgeName"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <!-- <el-col :span="6" class="list-block flex">
              <p class="title-txt">主审法官联系电话</p>
              <el-input
                v-model="currentLegalAffairs.presidingJudgePhone"
                class="input-block"
                placeholder="请输入内容"
                maxlength="11"
                clearable
              />
            </el-col> -->
            <el-col :span="4" class="list-block flex">
              <p class="title-txt">诉讼阶段</p>
              <el-input
                v-model="currentLegalAffairs.litigationStage"
                class="input-block"
                placeholder="请输入内容"
                clearable
              />
            </el-col>
            <el-col :span="8" class="list-block flex">
              <p class="title-txt">首次接收诉讼案件时间</p>
              <el-date-picker
                v-model="currentLegalAffairs.firstReceiveCase"
                type="date"
                class="input-block"
                placeholder="请输入内容"
                clearable
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              />
            </el-col>
          </el-row>
          <el-input
            v-model="legalPaper"
            type="textarea"
            class="textarea-block"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            :rows="3"
          />
          <div class="button-block flex">
            <el-button
              icon="el-icon-upload"
              type="primary"
              size="small"
              class="btn"
              :disabled="isCaseArchive"
              @click="onAddCaseAbstract(1004, 'legalPaper')"
            >
              提交
            </el-button>
          </div>
        </div>
      </el-card>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Abstract',

  props: {
    // 客诉记录基础信息
    appeals: {
      type: Object,
      default: () => {}
    },
    // 法务记录基础信息
    legalAffairs: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      // 摘要记录
      auditPaper: '', // 审核摘要
      communicationPaper: '', // 沟通摘要
      customerComplaintPaper: '', // 客诉摘要
      legalPaper: '', // 法务摘要
      // 客诉记录基础信息
      currentAppeals: {
        character: '', // 性格
        comprehension: '', // 理解能力
        appealOption: '', // 申诉类型
        content: '', // 客诉内容
        followUpTime: '', // 预约跟进时间
        name: '', // 申诉人姓名
        origin: '', // 来源
        times: '', // 申诉次数
        phone: '', // 联系方式
        result: '' // 申诉结果
      },
      // 申诉内容类型
      appealOptionList: [
        {
          value: '0',
          label: '不同意拒互助结论'
        },
        {
          value: '1',
          label: '不同意爱心互助'
        },
        {
          value: '2',
          label: '不同意低度互助'
        },
        {
          value: '3',
          label: '对不足额有疑问'
        },
        {
          value: '4',
          label: '不接受调查结论'
        },
        {
          value: '5',
          label: '不接受缴费'
        },
        {
          value: '6',
          label: '服务态度'
        },
        {
          value: '7',
          label: '其他'
        }
      ],
      // 法务记录基础信息
      currentLegalAffairs: {
        amountOfLitigation: '', // 诉讼金额
        caseNum: '', // 案号
        courtOfAppeal: '', // 受理法院
        defendant: '', // 被告
        defendantAgent: '', // 原告代理人
        firstReceiveCase: '', // 首次接收诉讼案件时间
        litigationStage: '', // 诉讼阶段
        plaintiff: '', // 原告
        presidingJudgeName: '' // 主审法官姓名
        // presidingJudgePhone: '' // 主审法官联系方式
      }
    }
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  watch: {
    // 监听“客诉记录基础信息”的变化
    appeals(newVal) {
      this.currentAppeals = newVal
    },
    // 监听“法务记录基础信息”的变化
    legalAffairs(newVal) {
      this.currentLegalAffairs = newVal
    }
  },

  methods: {
    /**
     * 添加摘要
     * @param {number} abstractType 摘要类型 1001,"审核摘要"; 1002,"沟通摘要"; 1003,"客诉摘要"; 1004,"法务摘要"
     * @param {string} key 存储的键值
     */
    async onAddCaseAbstract(abstractType, key) {
      const _this = this
      const { caseCode } = _this.caseInfo
      const content = _this[key]
      const params = { content, abstractType, caseCode }

      // 客诉记录基础信息
      if (Number(abstractType) === 1003) {
        params.appeals = _this.currentAppeals
      } else if (Number(abstractType) === 1004) {
        // 法务记录基础信息
        params.legalAffairs = _this.currentLegalAffairs
      }

      try {
        const { data: result } = await _this.axios.post(
          `/case-abstract/addCaseAbstract`,
          params
        )
        if (result && result.status === '000000') {
          _this.$alert('提交成功', '提示', {
            callback: () => {
              _this[key] = ''

              // 更新摘要信息
              _this.$emit('getCaseAbstract')
            }
          })
        } else {
          _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('疑点记录-增加-请求失败', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
